import React from 'react';
import numeral from 'numeral';
import { cn } from '@src/utils/ui';
import { Divider } from '@mui/material';
import PropTypes from 'prop-types';
import { Button } from '@src/components/ui/button/button';
import { formatDateTime } from '@src/utils/date/formatDateTime';
import { CostSummary } from '@src/views/features/checkout_flow_type/b2c/one-page-checkout/service_level/cost-summary';
import { RescheduleButton } from '../reschedule-button/reschedule-button';

export const TaskDetails = ({ detail = {}, onUpdateBookingSlot }) => {
    const { listing, price } = detail;
    const showReschedule = !['canceled', 'cancelled', 'completed', 'transferred', 'collected', 'released'].includes(
        detail.fulfillmentStatus.toLowerCase()
    );

    return (
        <>
            <div className='tw-text-[#0050C4]  tw-text-[24px] tw-font-[500]'>Task Number: {detail.taskNo}</div>
            <div className='tw-flex tw-flex-nowrap tw-flex-col lg:tw-flex-row tw-items-end tw-gap-[32px]'>
                <div className='tw-w-full lg:tw-w-[60%] tw-space-y-[32px] lg:tw-pl-[24px]'>
                    <div className='tw-grid tw-grid-cols-2 tw-gap-[16px]'>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Invoice Number</div>
                            <div>{detail.invoiceNo}</div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Fulfillment Status</div>
                            <div
                                className={cn([
                                    detail.fulfillmentStatus?.toLowerCase() === 'completed'
                                        ? 'tw-text-[#00B451] tw-font-[500]'
                                        : null,
                                    detail.fulfillmentStatus?.toLowerCase() === 'upcoming'
                                        ? 'tw-text-[#0050C4] tw-font-[500]'
                                        : null,
                                    detail.fulfillmentStatus?.toLowerCase() === 'transferred'
                                        ? 'tw-text-[#FF9500] tw-font-[500]'
                                        : null,
                                    detail.fulfillmentStatus?.toLowerCase() === 'collected'
                                        ? 'tw-text-[#00B451] tw-font-[500]'
                                        : null,
                                    ['cancelled', 'canceled'].includes(detail.fulfillmentStatus?.toLowerCase())
                                        ? 'tw-text-bcaa-red-helpful tw-font-[500]'
                                        : null
                                ])}
                            >
                                {detail.fulfillmentStatus}
                            </div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Tasker</div>
                            <div>{detail.sellerName}</div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Customer</div>
                            <div>{detail.buyerName}</div>
                            <div>{detail.deliveryAddress}</div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Task Issue Date</div>
                            <div>{formatDateTime(detail.orderDate, 'MM/DD/YYYY')}</div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Task Status</div>
                            <div>{detail.orderStatus}</div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Total</div>
                            <div>{numeral(detail.total).format('$0,0.00')}</div>
                        </div>
                        <div className='tw-text-[#333] tw-text-[16px]'>
                            <div className='tw-font-[500]'>Task Date</div>
                            <div>{formatDateTime(listing.startTime, 'MM/DD/YYYY')}</div>
                        </div>
                    </div>

                    <Divider className='tw-w-full' />

                    <div className='vq-full_details tw-flex tw-flex-col xl:tw-flex-row tw-w-full tw-gap-[32px] tw-items-end tw-justify-end '>
                        <div className='vq-details tw-flex tw-flex-col tw-gap-[24px] tw-w-full tw-flex-1'>
                            <div className='tw-flex tw-items-center tw-gap-[8px]'>
                                <img
                                    width={50}
                                    height={50}
                                    src={listing.imageUrl}
                                    className='tw-w-[50px] tw-h-[50px]'
                                    alt={listing.categoryName}
                                />
                                <span className='tw-text-[16px] tw-leading-[25.12px] tw-tracking-[0.1px] tw-font-[500]'>
                                    {listing.name}
                                </span>
                            </div>

                            <div className='tw-flex tw-flex-col tw-items-center tw-gap-[24px]'>
                                <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-items-center tw-gap-[24px] tw-w-full'>
                                    <div className='vq-schedule tw-flex tw-flex-col'>
                                        <div className='tw-flex tw-w-full tw-gap-[16px]'>
                                            <span className='tw-w-[100px] tw-text-[16px] tw-leading-[24px] tw-font-[500]'>
                                                Task Date:
                                            </span>
                                            <span className='tw-text-[16px] tw-leading-[24px]'>
                                                {formatDateTime(listing.startTime, 'MM/DD/YYYY')}
                                            </span>
                                        </div>
                                        <div className='tw-flex tw-w-full tw-gap-[16px]'>
                                            <span className='tw-w-[100px] tw-text-[16px] tw-leading-[24px] tw-font-[500]'>
                                                Time:
                                            </span>
                                            <span className='tw-text-[16px] tw-leading-[24px]'>
                                                {[listing.startTime, listing.endTime]
                                                    .filter(Boolean)
                                                    .map(time => formatDateTime(time, 'hh:mm A'))
                                                    .join(' to ')}
                                            </span>
                                        </div>
                                    </div>
                                    {onUpdateBookingSlot && showReschedule ? (
                                        <div>
                                            <RescheduleButton
                                                variant='outlined'
                                                className='tw-w-full'
                                                detail={detail}
                                                onUpdateBookingSlot={onUpdateBookingSlot}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                                <div className='tw-flex tw-flex-col tw-w-full'>
                                    <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>
                                        Description of work
                                    </span>
                                    <p className='tw-text-[16px] tw-leading-[24px]'>{listing.detailsOfWork}</p>
                                </div>
                                <div className='tw-flex tw-flex-col tw-w-full'>
                                    <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>
                                        Customer Instructions
                                    </span>
                                    <p className='tw-text-[16px] tw-leading-[24px]'>{listing.workRequirements}</p>
                                </div>
                                <div className='tw-flex tw-flex-col tw-w-full'>
                                    <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>Unit of work</span>
                                    <span className='tw-text-[16px] tw-leading-[24px]'>{listing.unitOfWork}</span>
                                </div>
                                <div className='tw-flex tw-flex-col tw-w-full'>
                                    <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>Quantity</span>
                                    <span className='tw-text-[16px] tw-leading-[24px]'>{listing.quantity}</span>
                                </div>
                                <div className='tw-flex tw-flex-col tw-w-full'>
                                    <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>Task Number</span>
                                    <span className='tw-text-[16px] tw-leading-[24px]'>{detail.taskNo}</span>
                                </div>
                                <div className='tw-flex tw-flex-col tw-w-full'>
                                    <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>
                                        Notes to Tasker
                                    </span>
                                    <span className='tw-text-[16px] tw-leading-[24px]'>
                                        <Button
                                            href={`/chat?channelId=${detail.channelId}`}
                                            variant='outlined'
                                            className='tw-w-full lg:tw-w-[unset]'
                                        >
                                            Show Chat Log
                                        </Button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='tw-w-full lg:tw-w-[40%]'>
                    <CostSummary price={price} addOns={listing.addOns} />
                </div>
            </div>
        </>
    );
};

TaskDetails.propTypes = {
    onUpdateBookingSlot: PropTypes.func,
    detail: PropTypes.shape({
        taskNo: PropTypes.string,
        invoiceNo: PropTypes.string,
        fulfillmentStatus: PropTypes.string,
        sellerName: PropTypes.string,
        buyerName: PropTypes.string,
        orderDate: PropTypes.string,
        taskDate: PropTypes.string,
        orderStatus: PropTypes.string,
        total: PropTypes.number,
        channelId: PropTypes.string,
        price: PropTypes.object,
        listing: PropTypes.shape({
            name: PropTypes.string,
            imageUrl: PropTypes.string,
            startTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            endTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            detailsOfWork: PropTypes.string,
            workRequirements: PropTypes.string,
            unitOfWork: PropTypes.string,
            quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
    })
};
